import React, { Fragment } from 'react';
import moment from 'moment';
import { MdMoreVert } from 'react-icons/md';
import { Popover } from '@mantine/core';

import PageLayout from 'PageLayout';
import { EButton, EPageTitle, ESelect, ETable, ETextArea } from 'libs/ui';

import useAffiliatePaymentRequest from '../../Affiliate/hooks/useAffiliatePaymentRequest';

export default function AffiliatePaymentRequest() {

    const {
        isLoading,
        paymentRequest,
        navigate,
        paymentRequestStatus,
        setPaymentRequestStatus,
        // goToNextPage,
        // goToPreviousPage,
        // disablePrev,
        // disableNext,
        selectedPaymentRequest,
        setSelectedPaymentRequest,
        updatePaymentRequestStatus
    } = useAffiliatePaymentRequest();

    return (
        <PageLayout>
            <EPageTitle
                title="Payment Request"
                end={
                    <EButton
                        onClick={() => navigate("/affiliate/accounts/create")}
                    >Create New</EButton>
                }
            />
            <div>
                <div className='filter-container'>
                    <ESelect
                        label="Payment Request Status"
                        data={[
                            { label: "Pending", value: "PENDING" },
                            { label: "Approved", value: "APPROVED" },
                            { label: "Rejected", value: "REJECTED" }
                        ]}
                        value={paymentRequestStatus}
                        onChange={(value) => {
                            setPaymentRequestStatus(value as "PENDING" | "APPROVED" | "REJECTED")
                        }}
                    />
                </div>

                <ETable
                    loading={isLoading}
                    pagination
                >
                    <thead>
                        <tr>
                            <th>Beneficiary Name</th>
                            <th>Cheque Number</th>
                            <th>Depositor Bank</th>
                            <th>Depositor Account No.</th>
                            <th>Amount</th>
                            <th>Date of Deposit</th>
                            <th>Date of Issue</th>
                            <th>
                                {
                                    paymentRequestStatus === "PENDING"
                                        ?
                                        ""
                                        :
                                        "Remark"
                                }
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            paymentRequest.map((eachRequest, index) => (
                                <Fragment key={index + "_fc"}>
                                    <tr>
                                        <td>{eachRequest?.beneficiaryName ?? "-"} {eachRequest?.beneficiaryBank ? `(${eachRequest?.beneficiaryBank})` : "-"}</td>
                                        <td>{eachRequest?.chequeDdNumber ?? "-"}</td>
                                        <td>{eachRequest?.depositorBankName ?? "-"} {eachRequest?.depositorBankBranch ? `(${eachRequest?.depositorBankBranch})` : "-"}</td>
                                        <td>{eachRequest?.depositorBankAccountNumber ?? "-"}</td>
                                        <td>{eachRequest?.depositAmount ?? "-"}{eachRequest?.depositType ? ` (${eachRequest?.depositType})` : "-"}</td>
                                        <td>{eachRequest.dateOfDeposit ? moment(eachRequest.dateOfDeposit).format("DD-MM-YYYY") : "-"}</td>
                                        <td>{eachRequest.chequeDdIssueDate ? moment(eachRequest.chequeDdIssueDate).format("DD-MM-YYYY") : "-"}</td>
                                        <td>
                                            {
                                                paymentRequestStatus === "PENDING"
                                                    ?
                                                    <Popover
                                                        withArrow
                                                        width={400}
                                                        arrowSize={12}
                                                        position="left"
                                                        shadow="md"
                                                        transitionProps={{ transition: "fade-left", duration: 300 }}
                                                        opened={selectedPaymentRequest.data?.id === eachRequest.id ? true : false}
                                                        onChange={() => setSelectedPaymentRequest({
                                                            data: null,
                                                            formData: {
                                                                status: "PENDING",
                                                                remark: null
                                                            },
                                                            isSaving: false
                                                        })}
                                                    >
                                                        <Popover.Target>
                                                            <div>
                                                                <MdMoreVert
                                                                    className="cursor-pointer"
                                                                    onClick={() => setSelectedPaymentRequest(prev => ({
                                                                        ...prev,
                                                                        data: eachRequest
                                                                    }))}
                                                                />
                                                            </div>
                                                        </Popover.Target>
                                                        <Popover.Dropdown>
                                                            <div className="flex flex-col gap-5">
                                                                <ESelect
                                                                    comboboxProps={{ withinPortal: false }}
                                                                    label="Payment Request Status"
                                                                    data={[
                                                                        { label: "Pending", value: "PENDING" },
                                                                        { label: "Approved", value: "APPROVED" },
                                                                        { label: "Rejected", value: "REJECTED" }
                                                                    ]}
                                                                    value={selectedPaymentRequest.formData.status}
                                                                    onChange={(value) => {
                                                                        setSelectedPaymentRequest(prev => ({
                                                                            ...prev,
                                                                            formData: {
                                                                                ...prev.formData,
                                                                                status: value as "PENDING" | "APPROVED" | "REJECTED"
                                                                            }
                                                                        }))
                                                                    }}
                                                                />

                                                                <ETextArea
                                                                    rows={3}
                                                                    label="Remark"
                                                                    placeholder="Enter a remark"
                                                                    value={selectedPaymentRequest.formData.remark ?? undefined}
                                                                    onChange={(e) => setSelectedPaymentRequest(prev => ({
                                                                        ...prev,
                                                                        formData: {
                                                                            ...prev.formData,
                                                                            remark: e.target.value
                                                                        }
                                                                    }))}
                                                                />

                                                                <EButton
                                                                    disabled={!selectedPaymentRequest.data?.id}
                                                                    loading={selectedPaymentRequest.isSaving}
                                                                    onClick={updatePaymentRequestStatus}
                                                                >Update</EButton>
                                                            </div>
                                                        </Popover.Dropdown>
                                                    </Popover>
                                                    :
                                                    eachRequest?.remarks ?? "-"
                                            }
                                        </td>
                                    </tr>
                                </Fragment>
                            ))
                        }
                    </tbody>
                </ETable>
            </div>
        </PageLayout>
    );

};